
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play-free",
      function () {
        return require("private-next-pages/play-free.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play-free"])
      });
    }
  